import React from 'react';
import { motion } from 'framer-motion';

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-white text-black relative overflow-hidden">
      {/* Floating bubble animation */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-gradient-to-br from-blue-200/30 to-purple-200/30 backdrop-blur-sm"
            style={{
              width: Math.random() * 200 + 100,
              height: Math.random() * 200 + 100,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`
            }}
            animate={{
              y: [0, -30, 0],
              x: [0, Math.random() * 20 - 10, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{
              duration: Math.random() * 5 + 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-2xl"
        >
          <h1 className="text-6xl md:text-7xl font-bold mb-6">
            Coming Soon — Stay Updated
          </h1>
          <p className="text-xl text-black/70 mb-12">
            We're building the future of intelligent systems.
          </p>

          {/* Optional email capture */}
          <form action="https://formsubmit.co/contact.neufora+v2@gmail.com"
          method="POST"
            className="max-w-md mx-auto"
          >
            <input
  type="hidden"
  name="_next"
  value="https://neufora.com/thank-you"
/>

            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_subject" value="Coming Soon - Email Signup" />
            
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                name="email"
                required
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-black/5 border border-black/20 rounded-xl focus:border-black/40 focus:outline-none transition-colors"
              />
              <button
                type="submit"
                className="px-8 py-3 bg-black text-white rounded-xl font-medium hover:scale-[1.02] transition-transform duration-200"
              >
                Notify Me
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default ComingSoon;